import { io } from "socket.io-client";

let socket = null;

export function connectAgencySocket(agencyId) {
  if (!agencyId) return null;

  const url = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL;

  if (!socket) {
    socket = io(url, {
      transports: ["websocket", "polling"],
      reconnection: true,
    });
  }

  const joinRoom = () => {
    socket.emit("joinAgencyRoom", agencyId);
  };

  if (socket.connected) {
    joinRoom();
  } else {
    socket.on("connect", joinRoom);
  }

  return socket;
}

export function disconnectAgencySocket(agencyId) {
  if (!socket) return;

  if (agencyId) {
    socket.emit("leaveAgencyRoom", agencyId);
  }

  socket.disconnect();
  socket = null;
}

export function getAgencySocket() {
  return socket;
}